<ng-container *ngLet="langChange$ | async">
  <form class="filter-container" *ngLet="disableObserver$ | async" [formGroup]="filterForm" (ngSubmit)="onSubmit()">
    <div class="header">
      <div class="button2-impaired-text-dark">{{ 'VERSION_VISUALLY_IMPAIRED.FILTER_BY_DATASET' | translate }}</div>
      <app-impaired-icon (clickOnIcon)="closeDialog()" [iconName]="icons.Close" [classSize]="'big-impaired'"></app-impaired-icon>
    </div>

    <div class="fields-container">
      <div class="section mt40">
        <span class="h3-impaired">{{ 'DATA.TABLE_FILTER.SET_TYPE' | translate }}:</span>

        <div class="row-group mt12">
          <label class="radio-container"
          >{{ 'DATA.TABLE_FILTER.ALL' | translate }}
            <input type="radio" [value]="null" name="datasetType" formControlName="datasetType" />
            <span class="radio"></span>
          </label>
          <label class="radio-container"
          >{{ 'LAYOUT.DATA' | translate }}
            <input type="radio" name="datasetType" [value]="false" formControlName="datasetType" />
            <span class="radio"></span>
          </label>

          <label class="radio-container"
          >{{ 'DATA.TABLE_FILTER.CLASSIFIERS' | translate }}
            <input type="radio" name="datasetType" [value]="true" formControlName="datasetType" />
            <span class="radio"></span>
          </label>
        </div>
      </div>

      <div class="horizontal-line mt24"></div>

      <div class="section mt16">
        <span class="h3-impaired">{{ 'DATA.TABLE_FILTER.DATASET_STATUS' | translate }}:</span>

        <div class="row-group mt12">
          <mat-checkbox formControlName="newRecommendedFavorites" class="body1-impaired">{{ 'DATA.TABLE_FILTER.NEW' | translate }}</mat-checkbox>
          <mat-checkbox formControlName="activeStatus" class="body1-impaired">{{ 'OTHER.ACTIVE' | translate }}</mat-checkbox>
          <mat-checkbox formControlName="archiveStatus" class="body1-impaired">{{ 'OTHER.ARCHIVES' | translate }}</mat-checkbox>
        </div>
      </div>

      <div class="horizontal-line mt24"></div>

      <div class="data-group mt24">
        <div class="data">
          <span class="button1-impaired-text">{{ 'DATA.TABLE_FILTER.DATA' | translate }}</span>
          <div class="data-filter mt16">
            <div class="h3-impaired mb16">{{ 'DATA.TABLE_HEADER.CATEGORY' | translate }}:</div>
            <mat-checkbox formControlName="accessibility" class="body1-impaired">{{ 'DATA.TABLE_FILTER.ACCESSIBILITY' | translate }}</mat-checkbox>

            <div class="h3-impaired mb16 mt40">{{ 'DATA.TABLE_FILTER.DATASETS_FOR_SPORTS_AND_REST' | translate }}:</div>
            <mat-checkbox formControlName="summerSeason" class="body1-impaired">{{ 'DATA.TABLE_FILTER.SUMMER' | translate }}</mat-checkbox>
            <mat-checkbox formControlName="winterSeason" class="body1-impaired">{{ 'DATA.TABLE_FILTER.WINTER' | translate }}</mat-checkbox>
            <mat-checkbox formControlName="allSeasons" class="body1-impaired"> {{ 'DATA.TABLE_FILTER.ALL_SEASON' | translate }}</mat-checkbox>
          </div>
        </div>
        <div class="data-card">
          <div class="data-filter">
            <div class="h3-impaired mb16" *ngIf="isRuLocale">{{ 'DATA.TABLE_FILTER.MAP_VIEW' | translate }}:</div>
            <mat-checkbox *ngIf="isRuLocale" formControlName="withMap" (change)="chooseMapFilter('withoutMap')" class="body1-impaired">{{
                'DATA.TABLE_FILTER.WITH_MAP' | translate
              }}</mat-checkbox>
            <mat-checkbox *ngIf="isRuLocale" formControlName="withoutMap" (change)="chooseMapFilter('withMap')" class="body1-impaired">{{
                'DATA.TABLE_FILTER.WITHOUT_MAP' | translate
              }}</mat-checkbox>

            <div [class.mt40]="isRuLocale" class="h3-impaired mb10">{{ 'DATA.TABLE_FILTER.STATIC_DATA' | translate }}:</div>
            <mat-checkbox formControlName="iso" class="body1-impaired">{{
                'DATA.TABLE_FILTER.ISO37120_AND_U4SSC_INDICATORS' | translate
              }}</mat-checkbox>
          </div>
        </div>
      </div>
      <div class="horizontal-line"></div>
      <div class="classifiers-container">
        <div class="button1-impaired-text mt16 mb10">{{ 'DATA.TABLE_FILTER.CLASSIFIERS_BIG' | translate }}</div>
        <div class="h3-impaired mb10">{{ 'DATA.TABLE_FILTER.CLASSIFIERS_TYPE' | translate }}:</div>
        <div class="classifiers-options-container">
          <mat-checkbox formControlName="ordinaryDict" class="body1-impaired">{{ 'DATA.TABLE_FILTER.STANDARD' | translate }}</mat-checkbox>
          <mat-checkbox formControlName="regionalDict" class="body1-impaired">{{ 'DATA.TABLE_FILTER.REGIONAL' | translate }}</mat-checkbox>
          <mat-checkbox formControlName="federalDict" class="body1-impaired">{{ 'DATA.TABLE_FILTER.FEDERAL' | translate }}</mat-checkbox>
        </div>
      </div>

      <div class="button-footer">
        <button class="button2-impaired setting-button" (click)="reset()" type="button">{{ 'OTHER.RESET_ALL' | translate }}</button>
        <button class="button2-impaired setting-button" type="submit">{{ 'OTHER.APPLY' | translate }}</button>
      </div>
    </div>
  </form>
</ng-container>
